import localEventNames from '@simplemining/dashboard/src/helpers/localEventNames/chips';
import classNames from 'classnames';
import emitLocalEvent from 'hooks/emitLocalEvent';

const maxValue = 999_999;

const GpuQuantityCell = (props: IGpuQuantityCell) => {
  const { state, row } = props;

  const value = state.find(element => row.id === element.id).quantity;
  const isGpuDataProvided = row.watts && row.hash;

  const classes = classNames('chip-quantity-cell', {
    'chip-quantity-cell--muted': !isGpuDataProvided,
  });

  const handleChange = e => {
    const input: string = e.target.value.replace(/[^0-9]/, '');

    const isToLong = input.length > String(maxValue).length;
    const isToBig = +input > maxValue;

    if (isToLong || isToBig) {
      return;
    }

    emitLocalEvent({
      eventName: localEventNames.chipsQuantity,
      data: {
        quantity: +input,
        row,
      },
    });
  };

  const subtract = () => {
    if (value > 0) {
      emitLocalEvent({
        eventName: localEventNames.chipsQuantity,
        data: {
          quantity: value - 1,
          row,
        },
      });
    }
  };

  const add = () => {
    if (value < maxValue) {
      emitLocalEvent({
        eventName: localEventNames.chipsQuantity,
        data: {
          quantity: value + 1,
          row,
        },
      });
    }
  };

  return (
    <div className={classes}>
      <button
        className="chip-quantity-cell__counter-subtract-btn"
        onClick={subtract}
        aria-label="subtract"
        disabled={value === 0 || !isGpuDataProvided}
      />
      <input
        type="text"
        inputMode="decimal"
        pattern="\d*"
        value={value}
        onChange={handleChange}
        disabled={!isGpuDataProvided}
        className="chip-quantity-cell__counter-input"
      />
      <button
        className="chip-quantity-cell__counter-add-btn"
        onClick={add}
        aria-label="add"
        disabled={value === maxValue || !isGpuDataProvided}
      />
    </div>
  );
};

export default GpuQuantityCell;
